import { RefObject } from 'react'
import { ActionCardsElement } from '@playbooks/action-cards'
import { ActionCardData, DataProvider, Dimension, Flow } from '@playbooks/action-cards-utils/src'
import { ActionCardsCallbacks, ActionCardsConfig, ActionCardsSettings } from '@playbooks/action-cards/types'

import type WebPlayActionCardService from './services/WebPlayActionCardService'
export interface SubmissionService {
  createPlay: (
    playbookId: string,
    title: string,
    keywords: string[],
    score: number,
    scoringDimensions: Dimension[],
    lastActiveSeparator: string | undefined,
    flow: Flow,
    loggedInUserId: string,
  ) => Promise<{ playId: string; fomToken: unknown }>
  attachFileToPlay: (
    playbookId: string,
    playId: string,
    headerId: string,
    headerName: string,
    file: File,
    fomToken: unknown,
  ) => Promise<[number, string]>
  attachActionCardToPlay: (playbookId: string, playId: string, actionCard: unknown, fomToken: unknown) => Promise<void>
  sendPlayCreatedNotification: (
    playbookId: string,
    playId: string,
    email: string,
    keywords: string[],
    actionCardModel: unknown,
    fomToken: unknown,
  ) => Promise<void>
  rollbackPlayCreation: (playbookId: string, playId: string, fomToken: unknown) => Promise<void>
  createAnonymousToken: () => Promise<string>
}

export interface WebPlayConfig {
  cdnUrl: string
  serviceBaseUrl: string
  playbooksBackendUrl: string
}

export interface WebPlaySettings {
  headersCount: number | null
  headline: string
  body: string
  redirectLink: string | null
  submitPrompt: string
  finalSlideLayout: string
  backgroundImage: string | null
  accentColor: string
  tenantName: string
  isMicrosoftClarityEnabled: boolean
  isGoogleAnalyticsEnabled: boolean
  isLoginRequired: boolean
  customCssFiles: string | null
  playTitleTemplate: string
  playTerm: string | null
  completionKeywords: string
  actionCardUrl: string
  logo: string
  darkModeLogo: string | null
  privacyUrl: string
  targetFrame: string
  enableFunnelView: boolean
  enableDocumentView: boolean
  weglotApiKey: string | null
  tenantCode: string
  loggedInUserId: number | null
  loggedInUserEmail: string | null
  isDarkTheme?: boolean
}

export type ViewMode = 'funnel' | 'doc' | 'default'

export interface AppContextValue {
  playbookId: string
  showScore: boolean
  email: string
  actionCardsElementRef: RefObject<ActionCardsElement | null>
  submissionService: SubmissionService
  actionCardService: WebPlayActionCardService
  isAccentColorDark: boolean
  actionCard: ActionCardData
  viewMode: ViewMode
  completionKeywords: Set<string> | null
  hasSections: boolean

  // Settings spread into context
  headersCount: number
  enableFunnelView?: boolean
  enableDocumentView?: boolean
  enablePrivacyPolicy?: boolean
  accentColor?: string
  submitPrompt?: string
  finalSlideLayout?: string
  playTitleTemplate?: string
  playTerm?: string
  privacyUrl?: string
  loggedInUserEmail?: string
  loggedInUserId?: string
  redirectLink?: string
  targetFrame?: string
  dataProvider?: DataProvider
  [key: string]: unknown
}

export type Status = {
  text?: string
  type?: 'error' | 'success' | 'warning'
}

export type ActionCardsDataProvider = {
  actionCardsSettings: ActionCardsSettings
  actionCardsCallbacks: ActionCardsCallbacks
  actionCardsConfig: ActionCardsConfig
}

export type SliderManager = {
  nextSlide: () => Step | undefined
  prevSlide: () => Step
  getCurrentStep: () => Step
} | null

export enum StepType {
  FIRST = 'first',
  LAST = 'last',
}

export type Step = {
  type: StepType | null
  step: number
  stepsNumber: number
  separatorId: number
}

export type QuestionFile = {
  questionId: number
  id: number
  header: Header
  file: File
}
export type Header = {
  id: number
  name: string
}
